import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ILoaderSettings {
  visible: boolean;
  hideOverlay: boolean;
}

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly loaderGlobalSubject = new Subject<ILoaderSettings>();
  private readonly loaderPageSubject = new Subject<ILoaderSettings>();

  loaderGlobalState = this.loaderGlobalSubject.asObservable();
  loaderPageState = this.loaderPageSubject.asObservable();

  constructor() {}

  showGlobalLoader(hideOverlay: boolean = false) {
    this.loaderGlobalSubject.next({ visible: true, hideOverlay });
  }

  showPageLoader(hideOverlay: boolean = false) {
    this.loaderPageSubject.next({ visible: true, hideOverlay });
  }

  hideGlobalLoader() {
    this.loaderGlobalSubject.next({ visible: false, hideOverlay: false });
  }

  hidePageLoader() {
    this.loaderPageSubject.next({ visible: false, hideOverlay: false });
  }
}
